<template>
    <main class="-mt-32">
        <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
            <div class="overflow-hidden bg-white shadow sm:rounded-md">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex rounded-md shadow-sm">
                        <div class="relative inline-block dropdown">
                            <button
                                @click="display = !display"
                                class="inline-flex items-center h-full px-4 py-2 mr-3 font-semibold text-gray-700 bg-gray-300 rounded"
                            >
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="w-5 h-5 text-gray-500"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                            </button>
                            <ul
                                :class="{'hidden': !display, 'block': display}"
                                class="absolute h-64 pt-1 mt-3 overflow-y-auto text-gray-700 border rounded shadow dropdown-menu"
                            >
                                <li
                                    v-for="year in years"
                                    :key="`year-${year.year}`"
                                    class=""
                                >
                                    <span
                                        class="block px-4 py-2 whitespace-no-wrap bg-white cursor-pointer hover:bg-gray-50"
                                        @click="setYear(year.year)"
                                    >{{year.year}}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="relative flex-grow focus-within:z-10">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="w-5 h-5 text-gray-400"
                                >
                                    <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"></path>
                                    <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"></path>
                                </svg>
                            </div>
                            <input
                                v-model="query"
                                class="block w-full pl-10 transition duration-150 ease-in-out rounded-none form-input rounded-l-md sm:text-sm sm:leading-5"
                            />
                        </div>
                        <router-link
                            tag="button"
                            :to="`/documents/new`"
                            class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-r-md hover:bg-indigo-500 focus:outline-none"
                        >
                            <svg
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                class="w-5 h-5"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="ml-2">Documento</span>
                        </router-link>
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                        <div class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow main-container sm:rounded-lg">
                            <div
                                class="scrollable"
                                @scroll="scroll"
                            >
                                <table class="min-w-full table-fixed">
                                    <thead>
                                        <tr>
                                            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
                                            <th class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:table-cell bg-gray-50">
                                                Tipo
                                            </th>
                                            <th class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:table-cell bg-gray-50">
                                                Numero
                                            </th>
                                            <th class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:table-cell bg-gray-50">
                                                Data
                                            </th>
                                            <th class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:table-cell bg-gray-50">
                                                Intestatario
                                            </th>
                                            <th class="table-cell px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:hidden bg-gray-50">
                                                Documento
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            :class="{'bg-gray-100': index %2}"
                                            v-for="(document, index) in filtered"
                                            :key="document.id"
                                        >
                                            <td class="flex px-6 py-4 text-sm font-medium leading-5 text-right whitespace-no-wrap">
                                                <router-link
                                                    :to="`/documents/${document.id}`"
                                                    class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                                                >
                                                    <svg
                                                        fill="currentColor"
                                                        viewBox="0 0 20 20"
                                                        class="w-5 h-5"
                                                    >
                                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                                                    </svg>
                                                </router-link>
                                                <span
                                                    @click="print(document)"
                                                    class="text-indigo-600 cursor-pointer hover:text-indigo-900 focus:outline-none focus:underline"
                                                >
                                                    <svg
                                                        fill="currentColor"
                                                        viewBox="0 0 20 20"
                                                        class="w-5 h-5"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
                                                            clip-rule="evenodd"
                                                        ></path>
                                                    </svg>
                                                </span>
                                            </td>
                                            <td class="hidden px-6 py-4 text-sm leading-5 text-gray-900 whitespace-no-wrap md:table-cell">
                                                {{ types[document.type_id] }}
                                            </td>
                                            <td class="hidden px-6 py-4 text-sm leading-5 text-right text-gray-500 whitespace-no-wrap md:table-cell">
                                                {{ document.number }}
                                            </td>
                                            <td class="hidden px-6 py-4 text-sm leading-5 text-right text-gray-500 whitespace-no-wrap md:table-cell">
                                                {{ document.date | prettydate }}
                                            </td>
                                            <td class="hidden px-6 py-4 text-sm font-medium leading-5 text-gray-500 whitespace-no-wrap md:table-cell">
                                                {{ document.name }}
                                            </td>
                                            <td class="table-cell px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap md:hidden">
                                                {{ types[document.type_id] }} {{ document.number }} {{ document.date | prettydate }}
                                                <br>
                                                {{ document.name }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        history: {
            required: false
        }
    },

    data: () => {
        return {
            loaded: false,
            display: false,
            query: "",
            elements: 0,
            pagination: 50,
            page: 1
        };
    },

    computed: {
        ...mapState("document", ["years", "year", "documents", "types"]),
        filtered() {
            this.loaded;
            return _.filter(this.documents, element => {
                return (
                    element.name
                        .toUpperCase()
                        .search(this.query.toUpperCase()) > -1 ||
                    element.name
                        .toUpperCase()
                        .search(this.query.toUpperCase()) > -1
                );
            })
                .sort(function(a, b) {
                    return a.date < b.date
                        ? 1
                        : a.date > b.date
                        ? -1
                        : a.number < b.number
                        ? 1
                        : -1;
                })
                .slice(0, this.page * this.pagination);
        }
    },

    methods: {
        scroll() {
            let container = $(".main-container");
            let height = container.scrollHeight - container.offsetHeight;
            let scrollTop = container.scrollTop;
            if (
                this.page * this.pagination < this.elements &&
                height - scrollTop < container.offsetHeight
            ) {
                this.page++;
            }
        },
        async setYear(year) {
            this.display = false;
            this.$store.dispatch("document/YEAR", year);
            await this.$store.dispatch("document/DOCUMENTS", {
                year: this.year
            });
            this.page = 1;
            this.elements = this.documents.length;
        },
        print(document) {
            this.$store.dispatch("document/PRINT", document);
        }
    },

    async mounted() {
        await this.$store.dispatch("document/YEARS");
        await this.$store.dispatch("document/DOCUMENTS", { year: this.year });
        this.elements = this.documents.length;
        this.loaded = true;
    }
};
</script>
